import { render, staticRenderFns } from "./MenuDropdownItem.vue?vue&type=template&id=72a7c92a"
import script from "./MenuDropdownItem.vue?vue&type=script&lang=ts"
export * from "./MenuDropdownItem.vue?vue&type=script&lang=ts"
import style0 from "./MenuDropdownItem.vue?vue&type=style&index=0&id=72a7c92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports